module.exports = __webpack_public_path__ + "static/media/oracle.4aab0d31.png";